export default "__VITE_ASSET__CpY7U0cz__"